// Khối "cấp key mới". Tách khỏi modal cho mỗi file còn ngắn.
//
// Trước đây 4 ô chỉ có placeholder xám nằm một hàng — gõ vào là mất chữ gợi ý, không
// còn biết ô nào là gì. Nay mỗi ô có nhãn cố định + 1 dòng giải thích.
import React from "react";
import { Button, Input, InputNumber, Select } from "antd";

/** Nhãn trên, ô giữa, giải thích xám dưới — giống khối cài đặt của bot Telegram. */
const Field = ({ label, hint, children }) => (
    <div>
        <div className="text-sm mb-1">{label}</div>
        {children}
        {hint && <div className="text-xs text-gray-500 mt-1">{hint}</div>}
    </div>
);

export default function ApiKeyCreateForm({
    scopeOptions,
    utilityScope,
    name,
    userId,
    scope,
    site,
    creating,
    onChange,
    onCreate,
}) {
    const isUtility = scope === utilityScope;
    return (
        <div className="grid grid-cols-2 gap-4">
            <Field label="Tên key" hint="Đặt theo nơi dùng để sau này biết thu hồi cái nào">
                <Input
                    placeholder="vd: bot telegram Back Mã"
                    value={name}
                    onChange={(e) => onChange({ name: e.target.value })}
                />
            </Field>

            {/* Cả bảng toàn id, nói rõ đây là id trên app longhousee cho khỏi điền nhầm. */}
            <Field
                label="Tài khoản gắn key (userId trên longhousee)"
                hint="Key mượn quyền của tài khoản này — bài đăng ra sẽ đứng tên họ"
            >
                <InputNumber
                    className="w-full"
                    min={1}
                    value={userId}
                    onChange={(value) => onChange({ userId: value })}
                />
            </Field>

            <Field label="Phạm vi" hint="Key chỉ gọi được nhóm endpoint của đúng phạm vi này">
                <Select
                    className="w-full"
                    value={scope}
                    onChange={(value) => onChange({ scope: value })}
                    options={scopeOptions}
                />
            </Field>

            {/* Chỉ scope tiện ích mới cần slug; để ô trống lơ lửng thì admin tưởng phải điền. */}
            {isUtility ? (
                <Field
                    label="Tiện ích được phép báo"
                    hint="Slug khai trong utility-notify-sites.js — key này không báo thay site khác được"
                >
                    <Input
                        placeholder="vd: yt"
                        value={site}
                        onChange={(e) => onChange({ site: e.target.value })}
                    />
                </Field>
            ) : (
                <div />
            )}

            <div className="col-span-2">
                <Button type="primary" loading={creating} onClick={onCreate}>
                    Tạo key
                </Button>
            </div>
        </div>
    );
}
